module.exports = __webpack_public_path__ + "static/media/loading-bars.9abe0e0b.svg";